module.exports = __webpack_public_path__ + "static/img/s206.1b2172e.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s206.png
// module id = 548
// module chunks = 3